import styled from "styled-components";

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
`;
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding: var(--sp-20);
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  max-width: calc(var(--u) * 500);
  margin: auto;
`;
export const CloseButton = styled.button`
  position: absolute;
  top: calc(var(--u) * 10);
  right: calc(var(--u) * 10);
  background: none;
  border: none;
  font-size: calc(var(--u) * 36);
  color: #ccc;
  cursor: pointer;
`;
export const Title = styled.h2`
width: 50%;
  text-align: center;
  font-size: var(--fs-2xl);
  margin-bottom: var(--sp-20);
`;
export const SubTitle = styled.p`
  text-align: center;
  font-size: var(--fs-base);
  margin-bottom: var(--sp-20);
`;
export const Input = styled.input`
  width: 100%;
  padding: var(--sp-10);
  margin-bottom: var(--sp-10);
  border: 1px solid #ccc;
  border-radius: 5px;
`;
export const DropDown = styled.select`
  width: 100%;
  padding: var(--sp-10);
  margin-bottom: var(--sp-10);
  border: 1px solid #ccc;
  border-radius: 5px;
`;
export const Button = styled.button`
  background-color: ${(props) => props.theme.colors.bluePrimary};
  color: white;
  padding: var(--sp-10) var(--sp-20);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.colors.bluePrimary};
  }
`;
export const customStyles = {
  overlay: {
    backgroundColor: "#00000100",
    zIndex: "1",
  },
  content: {
    border: "none",
    background: "none",
    padding: "0",
  },
};
